import { Api } from 'utils';

// Token de acceso de Apacuana (el "secretKey" del SDK). Vence cada 24h: lo
// renueva y persiste el backend (ApacuanaTokenService); la web solo lo pide.
class ApacuanaService {
  // Token vigente. El backend lo renueva si está por vencer.
  static getToken = async (params = {}) =>
    Api.createResponse('app/apacuana/token', { withoutLoading: true, ...params });

  // Para cuando Apacuana rechazó el token: el backend lo valida y, si de verdad
  // no sirve, genera uno nuevo (con lock en BD, un solo login aunque lo pidan varios).
  static refreshToken = async (params = {}) =>
    Api.createResponse('app/apacuana/token/refresh', { withoutLoading: true, ...params });
}

export default ApacuanaService;
